import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var BpgChapterHomePageService = /** @class */ (function () {
    function BpgChapterHomePageService() {
        this.bpgChapterDetailsSource = new BehaviorSubject('default message');
        this.bpgChapterData = this.bpgChapterDetailsSource.asObservable();
    }
    BpgChapterHomePageService.prototype.bpgChapterDetails = function (message) {
        this.bpgChapterDetailsSource.next(message);
    };
    BpgChapterHomePageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BpgChapterHomePageService_Factory() { return new BpgChapterHomePageService(); }, token: BpgChapterHomePageService, providedIn: "root" });
    return BpgChapterHomePageService;
}());
export { BpgChapterHomePageService };
